import React from 'react';
import PropTypes from 'prop-types';

import CustomRadioButton from '../custom_radio_button';
import { TEACHER_CANCEL_BUCKET_OPTIONS, derive_cancel_bucket } from './bucket_rules';

// PROD-7828 D4 quick-pick, shared by every team-cancel modal. Optional exact-time input auto-sets and locks the bucket.
function TeacherCancelBucketPicker(props) {
  const {
    value,
    onChange,
    error,
    requestedAt,
    onRequestedAtChange,
    sessionStartEpoch,
    ianaTimezone,
    timezoneLabel,
    lockedNote
  } = props;
  const withExactTime = typeof onRequestedAtChange === 'function';
  // lockedNote: the host derives the bucket from its own request-time field (PROD-7828 E1), so the radios only show it.
  const locked = (withExactTime && !!requestedAt) || !!lockedNote;

  const handleExactTime = (e) => {
    const next = e.target.value;
    onRequestedAtChange(
      next,
      next ? derive_cancel_bucket(sessionStartEpoch, next, ianaTimezone) : value
    );
  };

  return (
    <div style={{ margin: '10px 0' }}>
      <div style={{ fontWeight: 600, marginBottom: '6px' }}>
        When did the teacher request this cancellation?
      </div>
      {TEACHER_CANCEL_BUCKET_OPTIONS.map((option) => (
        <div
          key={option.value}
          style={{
            marginBottom: '6px',
            ...(locked ? { opacity: 0.6, pointerEvents: 'none' } : {})
          }}
        >
          <CustomRadioButton
            label={option.label}
            onRadioClick={() => onChange(option.value)}
            selected={value === option.value}
          />
        </div>
      ))}
      {lockedNote ? <div style={{ marginTop: '4px' }}>{lockedNote}</div> : null}
      {withExactTime ? (
        <div style={{ marginTop: '10px' }}>
          <div style={{ marginBottom: '4px' }}>
            Exact request time (optional, {timezoneLabel || ianaTimezone})
            {locked ? ' — bucket auto-set from this time' : ''}
          </div>
          <input
            type="datetime-local"
            value={requestedAt || ''}
            onChange={handleExactTime}
            style={{ width: '300px' }}
          />
        </div>
      ) : null}
      {error ? (
        <p style={{ color: 'var(--state-error)' }}>
          * Select when the teacher requested this cancellation
        </p>
      ) : null}
    </div>
  );
}

TeacherCancelBucketPicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
  requestedAt: PropTypes.string,
  onRequestedAtChange: PropTypes.func,
  sessionStartEpoch: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ianaTimezone: PropTypes.string,
  timezoneLabel: PropTypes.string,
  lockedNote: PropTypes.string
};

TeacherCancelBucketPicker.defaultProps = {
  value: '',
  error: false,
  requestedAt: '',
  onRequestedAtChange: undefined,
  sessionStartEpoch: undefined,
  ianaTimezone: undefined,
  timezoneLabel: '',
  lockedNote: ''
};

export default TeacherCancelBucketPicker;
